<div (offClick)="toggle(false)"
     [offClickOff]="!openState.value"
     class="pos-relative bg-col-w p-a-2 b-radius-4 _main-container"
     [toggleClassBy]="openState"
     [toggleClass]="'bg-col-6 !bg-col-w'">
    <!-- heading -->
    <div class="flex flex-middle cursor-pointer"
         (click)="toggle()">
        <!-- title -->
        <div class="flex-grow w-12 p1">
            @if (titleTpl) {
            <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
            }
        </div>
        <!-- icon -->
        <div class="m-l-2">
            <i class="icon-chevron-down icon-medium"></i>
        </div>
    </div>

    <!-- body -->
    <div class="pos-absolute top-100 m-t-2 z-1 box-shadow-1"
         [class.right-0]="rightPosition"
         [hideUp]="openState">
        <div class="bg-col-w p-a"
             [class._grid]="optionsAsGrid"
             [style.--number-of-rows]="numberOfRows">
            @for (option of options; track option; let last = $last) {
            <div class="cursor-pointer p2 _option"
                 [class.m-b-2]="!last && !optionsAsGrid"
                 (click)="pick(option)">
                @if (optionTpl) {
                <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }"></ng-container>
                }
            </div>
            }
        </div>
    </div>
</div>
